import { useState, useEffect } from 'react';

const navItems = [
  { label: 'Overview', href: '#overview' },
  { label: 'Vision', href: '#vision' },
  { label: 'Business', href: '#business' },
  { label: 'Products', href: '#products' },
  { label: 'Investment', href: '#investment' },
  { label: 'Network', href: '#network' },
  { label: 'Sustainability', href: '#sustainability' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#1A1A1A]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[104px] flex items-center justify-between">
        {/* Logo */}
        <a href="#overview" onClick={(e) => { e.preventDefault(); handleNav('#overview'); }} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/4f1b7e5c-a2f3-4971-ad44-a1a002cdfef9.png"
            alt="Bulk Ore Logo"
            className="h-[74px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.href)}
              className="text-[13px] uppercase tracking-widest text-[#CCCCCC] hover:text-[#A0A0A0] transition-colors duration-300 cursor-pointer whitespace-nowrap font-medium"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={() => handleNav('#contact')}
            className="whitespace-nowrap px-6 py-2.5 border border-[#888888] text-[#CCCCCC] text-[13px] uppercase tracking-widest rounded-full hover:bg-[#4A4A4A] hover:text-white transition-all duration-300 cursor-pointer font-semibold"
          >
            Get In Touch
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-[#CCCCCC] transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-[#CCCCCC] transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-[#CCCCCC] transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden bg-[#1A1A1A]/98 backdrop-blur-md ${
          menuOpen ? 'max-h-96 border-t border-[#888888]/20' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.href)}
              className="text-[13px] uppercase tracking-widest text-[#CCCCCC] hover:text-[#A0A0A0] transition-colors text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => handleNav('#contact')}
            className="whitespace-nowrap mt-2 px-6 py-2.5 border border-[#888888] text-[#CCCCCC] text-[13px] uppercase tracking-widest rounded-full text-left cursor-pointer"
          >
            Get In Touch
          </button>
        </div>
      </div>
    </nav>
  );
}
